import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=4bd3549e"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd3549e')) {
      api.createRecord('4bd3549e', component.options)
    } else {
      api.reload('4bd3549e', component.options)
    }
    module.hot.accept("./FormInput.vue?vue&type=template&id=4bd3549e", function () {
      api.rerender('4bd3549e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Products/Form/Restrictions/FormInput.vue"
export default component.exports